import PropTypes from 'prop-types';
import Oas, { Operation } from '../../../lib/api-explorer/models/Oas';
// @ts-expect-error Untyped
import findSchemaDefinition from '../../../lib/api-explorer/find-schema-definition';
// @ts-expect-error Untyped
import ResponseSchemaBody from './ResponseSchemaBody';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import H7 from 'UIComponents/elements/headings/H7';
import UISelect from 'UIComponents/input/UISelect';
import { useCallback, useState } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledMediaObject = styled(UIMediaObject).withConfig({
  displayName: "ResponseSchema__StyledMediaObject",
  componentId: "sc-1krkjpz-0"
})(["margin-bottom:7px;margin-top:4px;"]);
export const ResponseSchema = ({
  oas,
  operation,
  collapsible
}) => {
  const [state, setState] = useState({
    selectedStatus: Object.keys(operation.responses || {})[0]
  });
  const getContent = useCallback(() => {
    const status = state.selectedStatus;
    const response = operation && operation.responses && operation.responses[status];
    if (!response) return false;
    if (response.$ref) return findSchemaDefinition(response.$ref, oas).content;
    return response.content;
  }, [oas, operation, state.selectedStatus]);
  const getSchema = useCallback(() => {
    const content = getContent();
    if (!content) return null;
    const firstContentType = Object.keys(content)[0];
    if (content[firstContentType] && content[firstContentType].schema && content[firstContentType].schema.$ref) {
      return findSchemaDefinition(content[firstContentType].schema.$ref, oas);
    }
    if (content[firstContentType] && content[firstContentType].schema) {
      return content[firstContentType].schema;
    }
    return null;
  }, [getContent, oas]);
  const selectedStatus = useCallback(selected => {
    setState(currentState => Object.assign({}, currentState, {
      selectedStatus: selected
    }));
  }, []);
  const changeHandler = useCallback(e => {
    selectedStatus(e.target.value);
  }, [selectedStatus]);
  const renderHeader = useCallback(() => {
    const keys = Object.keys(operation.responses);
    return /*#__PURE__*/_jsx(StyledMediaObject, {
      align: "center",
      itemRight: /*#__PURE__*/_jsx(UISelect, {
        options: keys.map(status => ({
          text: status,
          value: status
        })),
        defaultValue: state.selectedStatus,
        buttonUse: "tertiary-light",
        buttonSize: "extra-small",
        onChange: changeHandler
      }),
      children: /*#__PURE__*/_jsx(H7, {
        className: "m-all-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.response.responseSchema.header"
        })
      })
    });
  }, [changeHandler, operation.responses, state.selectedStatus]);
  if (!operation.responses || Object.keys(operation.responses).length === 0) return null;
  const schema = getSchema();
  return /*#__PURE__*/_jsxs("div", {
    className: "schema-tab",
    children: [renderHeader(), /*#__PURE__*/_jsxs("div", {
      children: [operation.responses[state.selectedStatus].description && /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("p", {
          className: !schema ? 'm-bottom-0' : "",
          children: operation.responses[state.selectedStatus].description
        })
      }), schema && (schema.type || schema.oneOf) && /*#__PURE__*/_jsx(ResponseSchemaBody, {
        schema: schema,
        oas: oas,
        collapsible: collapsible
      })]
    })]
  });
};
ResponseSchema.propTypes = {
  operation: PropTypes.instanceOf(Operation).isRequired,
  oas: PropTypes.instanceOf(Oas).isRequired,
  collapsible: PropTypes.bool
};